const defaultRender = (value) => (value ? value : '--');

const columns = [
  {
    title: 'Name',
    dataIndex: 'name',
    render: (text) => <a>{text}</a>,
  },
  {
    title: 'Email',
    dataIndex: 'email',
    render: defaultRender,
    sorter: true,
  },
  {
    title: 'Mobile No',
    dataIndex: 'phoneNo',
    render: defaultRender,
  },
  {
    title: ' KYC type',
    dataIndex: 'kycType',
    render: defaultRender,
    sorter: true,
  },
 
  {
    title: 'Request Date',
    dataIndex: 'requestDate',
    render: defaultRender,
    sorter: true,
  },
  {
    title: 'Action Date',
    dataIndex: 'actionDate',
    render: defaultRender,
    sorter: true,
  },
  {
    title: 'Action By',
    dataIndex: 'actionBy',
    render: defaultRender,
    sorter: true,
  },
  {
    title: 'User Type',
    dataIndex: 'userType',
    render: defaultRender,
    sorter: true,
  },
  {
    title: 'Status',
    dataIndex: 'kycStatus',
    render: defaultRender,
    sorter: true,
  },
  {
    title: 'Actions',
    dataIndex: 'actions',
  }
];

export default columns;